<mat-card>
  <mat-card-title>
    Modification du document
  </mat-card-title>

  <app-document-edit [deposit]="data.box_obj.deposit_obj" [document]="data" [index]="0" [forceEdit]="true"
                     [documentsFormArray]="tmpForm"></app-document-edit>

  <mat-card-actions align="end">
    <button mat-raised-button color="accent" (click)="cancel()">Annuler</button>
    <button mat-raised-button color="warn" (click)="save()">Enregistrer</button>
  </mat-card-actions>
</mat-card>
